import React, { useEffect, useState } from 'react';

/**
 * Don't touch these imports!
 */
import { 
  fetchAllCenturies,
  fetchAllClassifications,
  fetchQueryResults,
  fetchAllMediums,
} from '../api';
import AutoFill from './AutoFill';

const Search = ({ setIsLoading, setSearchResults, setFeaturedResults }) => {

  const [centuryList, setCenturyList] = useState([]);
  const [classificationList, setClassificationList] = useState([]);
// added the medium list and medium to add new search parameter
  const [autoFill, setAutoFill] = useState({ info : {}, records : [],});
  const [mediumList, setMediumList] = useState([]);
  const [queryString, setQueryString] = useState('');
  const [century, setCentury] = useState('any');
  const [medium, setMedium] = useState('any');
  const [classification, setClassification] = useState('any');
  const [focused, setFocused] = useState(false);

  // Make sure to destructure setIsLoading and setSearchResults from the props
  useEffect(() => {
    Promise.all([
      fetchAllCenturies(),
      fetchAllClassifications(),
      fetchAllMediums(),
    ]).then( data => {
      setCenturyList(data[0]);
      setClassificationList(data[1]);
      setMediumList(data[2]);
    }
      ).catch( error => {
        console.error(error);
      })
  }, []);

  return <form id="search" onSubmit={async (event) => {
    // write code here
    event.preventDefault();
    setIsLoading(true);
    try {
      const search = await fetchQueryResults({ century, classification, medium, queryString });
      setSearchResults(search);
    } catch(errorObject){
      console.error('error', errorObject);
    } finally {
      setQueryString('');
      setIsLoading(false);
    }
  }}>
    <fieldset>
      <label htmlFor="keywords">Query</label>
      <input id="keywords" type="text" placeholder="enter keywords..." autoComplete='off'
        value={ queryString }
        onFocus={_ => setFocused(true)}
        onBlur={_ => setTimeout(() => {
          setFocused(false)
        }, 300)}
        onChange={async ev => {
          try{
            setQueryString(ev.target.value);
            let results = await fetchQueryResults({ century, classification, medium, queryString });
            setAutoFill(results);
          } catch (error) {
            console.error(error);
          }
        }
      }/>
      {// auto complete search results strech goal.
      /*
       only one bug with my search is that it's results are of by one. 
       I couldn't for the life of me figure out why it's not updating properly.
       */
          <ul className='searchFill'>
            {
              focused ?
                <AutoFill 
                  setAutoFill={ setAutoFill } 
                  autoFill={ autoFill }
                  setQueryString={ setQueryString }
                  setSearchResults={ setSearchResults }
                  setFeaturedResults={ setFeaturedResults }
                /> 
              : null
            }
          </ul>
      }  
    </fieldset>
    <fieldset>
      <label htmlFor="select-classification">Classification <span className="classification-count">({ classificationList.length })</span></label>
      <select 
        name="classification"
        id="select-classification"
        value={ classification } 
        onChange={ev => setClassification(ev.target.value) }>
        <option value="any">Any</option>
          {
            classificationList.map(classify => {
              return (
                <option value={ classify.name } key={ classify.id }>
                  { classify.name } 
                </option>
                )
            })
          }
      </select> 
    </fieldset>
    <fieldset>
    <label htmlFor="select-century">Century <span className="century-count">({ centuryList.length })</span></label>
      <select 
        name="century" 
        id="select-century"
        value={ century } 
        onChange={ ev => setCentury(ev.target.value) }>
        <option value="any">Any</option>
        {
          centuryList.map(century => {
            return (
              <option key={ century.id } value={ century.name }>
                { century.name }
              </option>
             )
           })
         }
       </select>
       
     </fieldset>
    {/* My added select <fieldset /> */}
    <fieldset>
      <label htmlFor='select-medium'>Medium <span className='medium-count'>({ mediumList.length })</span></label>
      <select
        name='medium'
        id='select-medium'
        value={ medium }
        onChange={ ev => setMedium(ev.target.value) }>
          <option value="any">Any</option>
          {
            mediumList.map(medium => {
              return (
                <option key={ medium.id } value={ medium.name }>
                  { medium.name }
                </option>
              )
            })
          }
      </select>     
    </fieldset>
    <button>SEARCH</button>
  </form>
}

export default Search;